export const driveSettingDescriptors = [
  {
    field: 'showInDock',
    helper: 'Display the ExpanDrive icon in the macOS Dock.',
    label: 'Show in Dock',
  },
  {
    field: 'startAtLogin',
    helper: 'Start ExpanDrive when a user signs in to their computer.',
    label: 'Launch at Login',
  },
  {
    field: 'revealAfterConnect',
    helper: 'Open the drive after it mounts successfully.',
    label: 'Reveal Drives After Connecting',
  },
  {
    field: 'showNotifications',
    helper: 'Notify users about connection and sync events.',
    label: 'Show Desktop Notifications',
  },
  {
    field: 'checkForUpdates',
    helper: 'Check for ExpanDrive updates in the background.',
    label: 'Automatically Check for Updates',
  },
  {
    field: 'disableOfflineSync',
    helper: 'Prevent local caching of remote files.',
    label: 'Disable Offline Sync',
  },
]
